/**
 * @description CSS Units
 */
export enum CSSUnit {
	PIXEL = 'px',
	PERCENT = '%',
	EM = 'em'
}